/* eslint-disable no-console */
export const envVars = {
    local: {
        REACT_APP_NEW_PATIENT_LOOKUP_API_URI: 'http://localhost:8080/patient/searchPatient',
        apiUrl: 'https://dserxps.api.dev.at-npd.ascension.org/rx-onboarding-api',
        REACT_APP_API_KEY_URI: "Uz9Jc2XkqmLsYIeG52nmzetqmrjpWeyt",
    },
    dev: {
        REACT_APP_NEW_PATIENT_LOOKUP_API_URI: 'https://dev-api.ascension.org/rxonboardingapi',
        apiUrl: 'https://dserxps.api.dev.at-npd.ascension.org/rx-onboarding-api',
        REACT_APP_PATIENT_LOOKUP_API_URI: "https://dserxps.api.dev.at-npd.ascension.org/rx-onboarding-api/patient/searchPatient",
        REACT_APP_API_KEY_URI: "Uz9Jc2XkqmLsYIeG52nmzetqmrjpWeyt",
    },
    qa: {
        REACT_APP_NEW_PATIENT_LOOKUP_API_URI: 'https://qa-api.ascension.org/rxonboardingapi',
        apiUrl: 'https://qa-api.ascension.org/rxonboardingapi',
        REACT_APP_PATIENT_LOOKUP_API_URI: "https://qa-api.ascension.org/rxonboardingapi/patient/searchPatient",
        REACT_APP_API_KEY_URI: "Uz9Jc2XkqmLsYIeG52nmzetqmrjpWeyt",
    },
    uat: {
        REACT_APP_NEW_PATIENT_LOOKUP_API_URI: 'https://uat-api.ascension.org/rxonboardingapi',
        apiUrl: 'https://dserxps.api.uat.at-ppd.ascension.org/rx-onboarding-api',
        REACT_APP_PATIENT_LOOKUP_API_URI: "https://uat-api.ascension.org/rxonboardingapi/patient/searchPatient",
        REACT_APP_API_KEY_URI: "Uz9Jc2XkqmLsYIeG52nmzetqmrjpWeyt",
    },
    prod: {
        REACT_APP_NEW_PATIENT_LOOKUP_API_URI: 'https://prod-api.ascension.org/rxonboardingapi',
        apiUrl: 'https://prod-api.ascension.org/rxonboardingapi',
        REACT_APP_PATIENT_LOOKUP_API_URI: "https://prod-api.ascension.org/rxonboardingapi/patient/searchPatient",
        REACT_APP_API_KEY_URI: "TjQr0TDZn5hoFS03Soe6AlkHd378lnnA",
    },
};

export const getEnvVars = host => {
    switch (true) {
        case host.includes('localhost'):
            return envVars.local;
        case host.includes('.dev.'):
            return envVars.dev;
        case host.includes('.qa.'):
            return envVars.qa;
        case host.includes('.uat.'):
            return envVars.uat;
        case host.includes('.pub.at.'):
            return envVars.prod;
        default:
            console.error('Failed to load configuration', {
                code: 'env_not_detected',
                desc: 'host url does not match known environments'
            });
            return {};
    }
};

export const getApiKey = ()=>'Uz9Jc2XkqmLsYIeG52nmzetqmrjpWeyt'
